import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import pricingBackground from "./assets/pricingbackground.png";

export default function LandingPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const baseBtn = "px-6 py-3 rounded-md text-white text-base font-medium";
  const blueBtn = `${baseBtn} bg-[#1976d2] hover:bg-[#1565c0]`;

  const slabImages = [
    "/Pujolsslab.webp",
    "/charizardslab.webp",
    "/onepieceslab.webp",
    "/williamsslab.webp",
  ];

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <div className="min-h-screen flex flex-col relative text-white">
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: "url('/webbackground.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
        className="w-full"
      >
        <nav
          className="flex justify-end items-center px-6 py-2 relative z-20"
          style={{ background: "rgba(0,0,0,0)", boxShadow: "none" }}
        >
          <div className="flex gap-3 items-center">
            <button
              className={blueBtn}
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700 }}
              onClick={() => navigate("/login")}
            >
              Login
            </button>
            <button
              className={blueBtn}
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700 }}
              onClick={() => navigate("/signup")}
            >
              Sign Up
            </button>
            <div style={{ width: 20 }} />
            <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
          </div>
        </nav>

        <section className="flex flex-col justify-start items-center text-center px-6 w-full">
          <h1
            className="text-[3.375rem] sm:text-[3.75rem] mt-[2vh] mb-1"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 900,
              color: "#fff",
              lineHeight: 1.1,
              letterSpacing: "-0.03em",
              textShadow: "0 4px 24px rgba(0,0,0,0.15)",
              whiteSpace: "nowrap",
            }}
          >
            Get More 10s.
          </h1>
          <h2
            className="mb-4 sm:mb-8"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 400,
              fontSize: "1.5rem",
              color: "#fff",
              textShadow: "0 2px 8px rgba(0,0,0,0.10)",
            }}
          >
            Expert Insights <span style={{ fontWeight: 700 }}>BEFORE</span> You Send It Off.
          </h2>

          {/* Mobile Slabs */}
          <div
            className="w-full flex flex-nowrap justify-center gap-4 sm:hidden"
            style={{ marginTop: "0.5rem", marginBottom: "0rem" }}
          >
            {[slabImages[0], slabImages[1]].map((src, idx) => (
              <div key={idx} className="flex justify-center items-center w-[45%]">
                <img
                  src={src}
                  alt={`PSA Slab ${idx + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "0.75rem",
                    boxShadow: "0 4px 16px 0 rgba(0,0,0,0.15)",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Desktop Slabs */}
          <div
            className="hidden sm:flex w-full flex-nowrap justify-center gap-6 overflow-x-auto px-0 mx-0"
            style={{ maxWidth: "1000px", margin: "1rem 0 0 0" }}
          >
            {slabImages.map((src, idx) => (
              <div
                key={idx}
                className="flex justify-center items-center bg-transparent"
                style={{ minWidth: 199, maxWidth: 259, flex: "0 0 23%" }}
              >
                <img
                  src={src}
                  alt={`PSA Slab ${idx + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "1.2rem",
                    boxShadow: "0 4px 16px 0 rgba(0,0,0,0.15)",
                  }}
                />
              </div>
            ))}
          </div>

          <button
            className="px-10 py-4 mt-4 sm:mt-6 mb-4 sm:mb-12 rounded-xl text-white font-bold text-lg shadow-lg transition-all duration-200"
            style={{
              background: "#1976d2",
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: "0.02em",
              boxShadow: "0 4px 24px 0 rgba(25, 118, 210, 0.25)",
            }}
            onClick={() => navigate("/signup")}
          >
            Get Started
          </button>
        </section>
      </div>

      {/* How It Works Section */}
      <section
        className="w-full pt-10 sm:pt-16 pb-16 sm:pb-24 flex flex-col items-center relative overflow-hidden"
        style={{ backgroundColor: "#1b1b1b" }}
      >
        <div className="absolute top-0 left-0 w-full h-12 bg-gradient-to-b from-black to-[#1b1b1b] z-0" />
        <h2
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 800,
            fontSize: "2.25rem",
            color: "#fff",
            marginBottom: "1.5rem",
            letterSpacing: "-0.01em",
          }}
        >
          How It Works
        </h2>
        <div
          className="w-full flex justify-center items-center relative z-10 px-4"
          style={{ maxWidth: "1000px", margin: "0 auto" }}
        >
          <div
            className="rounded-2xl w-full aspect-video overflow-hidden"
            style={{ maxWidth: "800px" }}
          >
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/fc9B8GcUP-o"
              title="How It Works: Submission Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-black to-[#1b1b1b] z-0" />
      </section>

      {/* Pricing Section (mirrors Pricing page layout & copy) */}
      <section
        className={`w-full py-16 flex flex-col items-center bg-black sm:bg-cover sm:bg-center sm:bg-no-repeat`}
        style={{
          backgroundImage: `url(${pricingBackground})`,
        }}
      >
        <div
          className="rounded-2xl bg-black bg-opacity-80 p-10 w-[95%] sm:w-full max-w-3xl text-white text-center"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <h2 className="text-3xl font-extrabold mb-4 tracking-tight">Pricing</h2>

          {/* Mobile text */}
          <p className="text-lg mb-10 px-4 font-semibold sm:hidden">
            Each Submission = <strong>1 Credit</strong>
          </p>

          {/* Desktop text */}
          <p className="text-lg mb-10 px-4 font-semibold hidden sm:block">
            Each submission requires <strong>1 CREDIT</strong>.<br />
            Credits can be purchased in two different quantities:
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="bg-white text-black rounded-2xl shadow-lg p-6 min-w-[220px] max-w-[280px]">
              <h3 className="text-xl font-bold mb-2">1 Credit</h3>
              <p className="text-lg font-semibold mb-2">$4.49</p>
            </div>

            <div className="bg-white text-black rounded-2xl shadow-lg p-6 min-w-[220px] max-w-[280px]">
              <h3 className="text-xl font-bold mb-2">5 Credits</h3>
              <p className="text-lg font-semibold mb-2">$14.99</p>
              <p className="text-sm text-green-600">Save ~33%</p>
            </div>
          </div>
        </div>

        <div
          className="mt-8 text-base text-white text-center"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <p className="mb-3">
            Have grading experience? Apply{" "}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSddi7tg2zsr_crNDsrXu41aeXzajKrTlNdCqwZUUqLzcwOLMw/viewform?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-400"
            >
              here
            </a>
            .
          </p>
          <div className="text-sm text-gray-400 flex justify-center gap-2">
            <a href="/faqs" className="hover:underline">
              Help
            </a>
            <span>|</span>
            <a href="/terms-of-service" className="hover:underline">
              Terms of Service
            </a>
            <span>|</span>
            <a href="/contact" className="hover:underline">
              Contact
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
